import Auth from "src/Auth";
import { create } from "zustand";

export const useWorkflowStore = create((set, get) => ({
  workflows: {},
  creatingNewVersion: false,
  availableEngines: [],
  setCreatingNewVersion: (creatingNewVersion) => {
    set({ creatingNewVersion });
  },
  setWorkflows: (workflows) =>
    set({
      workflows: workflows.reduce((acc, workflow) => {
        acc[workflow.id] = workflow;
        return acc;
      }, {}),
    }),
  createUserWorkflow: async () => {
    const result = await Auth.fetchWithIdToken(`/api/workflows/createUserWorkflow`);
    set({ workflows: { ...get().workflows, [result.workflow.id]: result.workflow } });
    return result.workflow;
  },
  updateWorkflow: (updatedWorkflow) =>
    set((state) => ({
      workflows: {
        ...state.workflows,
        [updatedWorkflow.id]: updatedWorkflow,
      },
    })),
  createNewVersion: async (workflowId, parentVersionId, abTestName, abTestWinner) => {
    set({ creatingNewVersion: true });
    const result = await Auth.fetchWithIdToken(`/api/workflows/${workflowId}/newVersion`, {
      method: "POST",
      parentVersionId,
      abTestName,
      abTestWinner,
    });
    set({
      workflows: {
        ...get().workflows,
        [result.workflow.id]: result.workflow,
      },

      creatingNewVersion: false,
    });
    return result;
  },
  getAvailableEngines: async () => {
    const result = await Auth.fetchWithIdToken(`/api/workflows/availableEngines`);
    set({ availableEngines: result.engines });
  },
}));
